const ITEMS = [
  "Groom Styling",
  "Family Wedding Outfits",
  "In-Home Punjab Visits",
  "Virtual Consultations Worldwide",
  "By Appointment Only",
  "+91 88013 87013",
];

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#E5DEC9] bg-[#F4EFE6] py-6"
    >
      <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
        {[...ITEMS, ...ITEMS].map((text, i) => (
          <span
            key={i}
            className="flex items-center gap-12 text-xs font-medium uppercase tracking-[0.4em] text-[#686152]"
          >
            {text}
            <span className="text-[#C5A059]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
